import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAdmin } from '../lib/roles';
import './Tenders.css';

export default function Tenders() {
  const { role } = useAuth();
  const location = useLocation();
  const secondSegment = location.pathname.split('/')[2];
  const isDetailsPage =
    secondSegment && secondSegment !== 'proposals';
  const showTenderListTab = isAdmin(role);

  return (
    <div className="tenders-module">
      {!isDetailsPage && (
        <div className="tenders-card tenders-tabs-card">
          <div className="tenders-header-row">
            <h1 className="tenders-title">Tenders and proposals</h1>
            <nav className="tenders-tabs" aria-label="Tender sections">
              {showTenderListTab && (
                <NavLink
                  to="/tenders"
                  end
                  className={({ isActive }) => `tenders-tab ${isActive ? 'active' : ''}`}
                >
                  Tender List
                </NavLink>
              )}
              <NavLink
                to="/tenders/proposals"
                className={({ isActive }) => `tenders-tab ${isActive ? 'active' : ''}`}
              >
                Proposals
              </NavLink>
            </nav>
          </div>
        </div>
      )}
      {!showTenderListTab && location.pathname === '/tenders' && (
        <div className="tenders-page-card" style={{ padding: '2rem', textAlign: 'center' }}>
          <p style={{ fontSize: '1.1rem', color: 'var(--text-muted)' }}>
            You need access to see this information.
          </p>
        </div>
      )}
      {!(!showTenderListTab && location.pathname === '/tenders') && <Outlet />}
    </div>
  );
}
